import { createPersistedState } from "pinia-plugin-persistedstate";
import { defineNuxtPlugin, useRuntimeConfig } from "#app";

export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig();

  const pinia = useNuxtApp()?.$pinia;

  if (!pinia) {
    throw new Error(
      "Pinia is not installed, could not install persistence plugin"
    );
  }

  pinia.use(
    createPersistedState({
      key: (storeKey) =>
        `${
          config.public.companyProfileName?.toLowerCase() ?? "order"
        }:${storeKey}`,
    })
  );
});
